module.exports = __webpack_public_path__ + "img/bull_lol1.6ded93d6.png";